<template>
  <div>
    <Toast position="top-center" group="shopping-cart">
      <template #message="slotProps">
        <span
          :class="[
            'p-toast-message-icon pi',
            {
              'pi-info-circle': slotProps.message.severity === 'info',
              'pi-exclamation-triangle': slotProps.message.severity === 'warn',
              'pi-times': slotProps.message.severity === 'error',
              'pi-check': slotProps.message.severity === 'success',
            },
          ]"
        ></span>
        <div class="p-toast-message-text">
          <span class="p-toast-summary">{{ slotProps.message.summary }}</span>
          <!-- <div class="p-toast-detail" v-html="slotProps.message.detail" /> -->
          <div class="p-toast-detail">
            <div
              v-if="slotProps.message.detail.succeed.length > 0"
              class="toast-category"
            >
              <div
                class="summary"
                v-if="
                  slotProps.message.detail.succeed.length > 0 &&
                  slotProps.message.detail.failed.length > 0
                "
              >
                成功
              </div>
              <div class="detail">
                <ul class="list-disc">
                  <li
                    :key="content"
                    v-for="content in slotProps.message.detail.succeed"
                  >
                    {{ content }}
                  </li>
                </ul>
              </div>
            </div>

            <div
              v-if="slotProps.message.detail.failed.length > 0"
              class="toast-category"
            >
              <div
                class="summary"
                v-if="
                  slotProps.message.detail.succeed.length > 0 &&
                  slotProps.message.detail.failed.length > 0
                "
              >
                失敗
              </div>
              <div clas="detail">
                <ul class="list-disc">
                  <li
                    :key="content"
                    v-for="content in slotProps.message.detail.failed"
                  >
                    {{ content }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Toast>

    <OverlayPanel ref="QuickAdd_Pack" :dismissable="true" appendTo="body">
      <div v-if="contains_is_loading" class="w-[300px] h-[280px]">
        <div>讀取商品資訊中…</div>
        <div class="my-2">
          <Skeleton height="50px" class="my-2" />
          <Skeleton height="50px" class="my-2" />
          <Skeleton height="50px" class="my-2" />
        </div>
      </div>
      <div v-else>
        <div
          v-if="product.type == 'pack'"
          class="min-w-[300px] max-w-full h-[280px]"
        >
          <!-- 組合包 -->
          <div>
            <template v-if="product.attributes?.type?.mode == 'fixed'">
              <!-- 固定 -->
              <div>包含以下商品：</div>
              <div class="my-2 h-[160px] overflow-auto">
                <div
                  :key="item.id + '_' + index"
                  v-for="(item, index) in product.options"
                  class="flex flex-nowrap flex-row justify-start items-center my-1 cursor-zoom-in hover:bg-fh-gray-bg"
                  @click="goToProductPage(item.slug)"
                >
                  <div class="w-[50px]">
                    <img
                      v-if="
                        Array.isArray(item.images) && item.images.length > 0
                      "
                      class="object-cover aspect-square pack-product-image"
                      :src="
                        '/storage/product-images/' + item.images[0] + '/50.jpg'
                      "
                    />
                    <img
                      v-else
                      class="object-cover aspect-square pack-product-image"
                      src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                    />
                  </div>
                  <div class="mx-3">{{ item.name }}</div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="product.multiple !== true">
                <!-- 單選 -->
                <TabView :activeIndex.sync="tab_index">
                  <TabPanel
                    :header="'選擇 (' + product.attributes.type.quantity + ')'"
                  >
                    <div class="w-full h-[160px] overflow-auto">
                      <div
                        :key="item.id + '_' + index"
                        v-for="(item, index) in product.options"
                        class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                      >
                        <div class="mr-2">
                          <Button
                            icon="pi pi-plus"
                            class="p-button-rounded p-button-text"
                            :disabled="check_single_selection(item)"
                            @click="select_item(item)"
                          />
                        </div>
                        <div class="w-[50px]">
                          <img
                            v-if="
                              Array.isArray(item.images) &&
                              item.images.length > 0
                            "
                            class="object-cover aspect-square pack-product-image"
                            :src="
                              '/storage/product-images/' +
                              item.images[0] +
                              '/50.jpg'
                            "
                          />
                          <img
                            v-else
                            class="object-cover aspect-square pack-product-image"
                            src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                          />
                        </div>
                        <div class="mx-3">{{ item.name }}</div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    :header="'已選 (' + product.includes.length + ')'"
                    :disabled="product.includes.length == 0"
                  >
                    <div class="w-full h-[160px] overflow-auto">
                      <div
                        :key="item.id + '_' + index"
                        v-for="(item, index) in product.includes"
                        class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                      >
                        <div class="mr-2">
                          <Button
                            icon="pi pi-times"
                            class="p-button-rounded p-button-text"
                            @click="delete_item(index)"
                          />
                        </div>
                        <div class="w-[50px]">
                          <img
                            v-if="
                              Array.isArray(item.images) &&
                              item.images.length > 0
                            "
                            class="object-cover aspect-square pack-product-image"
                            :src="
                              '/storage/product-images/' +
                              item.images[0] +
                              '/50.jpg'
                            "
                          />
                          <img
                            v-else
                            class="object-cover aspect-square pack-product-image"
                            src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                          />
                        </div>
                        <div class="mx-3">{{ item.name }}</div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
              </template>
              <template v-else>
                <!-- 多選 -->
                <TabView :activeIndex.sync="tab_index">
                  <TabPanel
                    :header="'選擇 (' + product.attributes.type.quantity + ')'"
                  >
                    <div class="w-full h-[160px] overflow-auto">
                      <div
                        :key="item.id + '_' + index"
                        v-for="(item, index) in product.options"
                        class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                      >
                        <div class="mr-2">
                          <Button
                            icon="pi pi-plus"
                            class="p-button-rounded p-button-text"
                            :disabled="check_multiple_selection(item)"
                            @click="select_item(item)"
                          />
                        </div>
                        <div class="w-[50px]">
                          <img
                            v-if="
                              Array.isArray(item.images) &&
                              item.images.length > 0
                            "
                            class="object-cover aspect-square pack-product-image"
                            :src="
                              '/storage/product-images/' +
                              item.images[0] +
                              '/50.jpg'
                            "
                          />
                          <img
                            v-else
                            class="object-cover aspect-square pack-product-image"
                            src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                          />
                        </div>
                        <div class="mx-3">{{ item.name }}</div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel
                    :header="'已選 (' + product.includes.length + ')'"
                    :disabled="product.includes.length == 0"
                  >
                    <div class="w-full h-[160px] overflow-auto">
                      <div
                        :key="item.id + '_' + index"
                        v-for="(item, index) in product.includes"
                        class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                      >
                        <div class="mr-2">
                          <Button
                            icon="pi pi-times"
                            class="p-button-rounded p-button-text"
                            @click="delete_item(index)"
                          />
                        </div>
                        <div class="w-[50px]">
                          <img
                            v-if="
                              Array.isArray(item.images) &&
                              item.images.length > 0
                            "
                            class="object-cover aspect-square pack-product-image"
                            :src="
                              '/storage/product-images/' +
                              item.images[0] +
                              '/50.jpg'
                            "
                          />
                          <img
                            v-else
                            class="object-cover aspect-square pack-product-image"
                            src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                          />
                        </div>
                        <div class="mx-3">{{ item.name }}</div>
                      </div>
                    </div>
                  </TabPanel>
                </TabView>
              </template>
            </template>
          </div>
          <!-- /組合包 -->
          <div v-if="show_quantity" class="text-center">
            <InputNumber
              :disabled="should_disable"
              v-model="product.quantity"
              showButtons
              :step="1"
              suffix="個"
              decrementButtonClass="quick-add-decrease_button"
              incrementButtonClass="quick-add-increase_button"
              incrementButtonIcon="pi pi-plus"
              decrementButtonIcon="pi pi-minus"
              inputClass="w-16"
              :min="1"
              :max="product.stock"
            />
          </div>
          <div class="text-center mt-1">
            <Button
              class="p-button-sm p-button-text"
              label="加入購物車"
              icon="pi pi-plus-circle"
              iconPos="left"
              @click="addToShoppingCart"
              :disabled="
                product.stock < 1 ||
                product.quantity > product.stock ||
                should_disable ||
                not_able_to_add
              "
            />
          </div>
        </div>
        <!-- /組合包 -->
      </div>
    </OverlayPanel>

    <OverlayPanel ref="QuickAdd" :dismissable="true" appendTo="body">
      <div v-if="product.type != 'pack'">
        <div v-if="show_quantity" class="text-center">
          <InputNumber
            :disabled="should_disable"
            v-model="product.quantity"
            showButtons
            :step="1"
            suffix="個"
            decrementButtonClass="quick-add-decrease_button"
            incrementButtonClass="quick-add-increase_button"
            incrementButtonIcon="pi pi-plus"
            decrementButtonIcon="pi pi-minus"
            inputClass="w-16"
            :min="1"
            :max="product.stock"
          />
        </div>
        <div class="text-center mt-1">
          <Button
            class="p-button-sm p-button-text"
            label="加入購物車"
            icon="pi pi-plus-circle"
            iconPos="left"
            @click="addToShoppingCart"
            :disabled="
              product.stock < 1 ||
              product.quantity > product.stock ||
              should_disable ||
              not_able_to_add
            "
          />
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
import Toast from "primevue/toast";
import OverlayPanel from "primevue/overlaypanel";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import Skeleton from "primevue/skeleton";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  components: {
    Toast,
    OverlayPanel,
    InputNumber,
    Button,
    Skeleton,
    TabView,
    TabPanel,
  },
  props: {
    ShoppingCart: {
      type: Object,
      default() {
        return { product: {} };
      },
    },
  },
  data() {
    return {
      show_quantity: true,
      should_disable: false,
      not_able_to_add: false,
      contains_is_loading: true,
      product: {
        name: null,
        type: null,
        id: null,
        includes: null,
        quantity: 0,
        stock: 0,
      },
      tab_index: 0,
    };
  },
  computed: {
    //
  },
  methods: {
    check_single_selection(item) {
      return (
        this.product.includes.some((existing) => {
          return existing.id == item.id;
        }) ||
        this.product.includes.length == this.product.attributes.type.quantity
      );
    },
    check_multiple_selection(item) {
      return (
        this.product.includes.length == this.product.attributes.type.quantity
      );
    },
    check_ability_of_add() {
      if (
        this.product.includes.length < this.product.attributes.type.quantity
      ) {
        this.not_able_to_add = true;
        return;
      }

      this.not_able_to_add = false;
    },
    select_item(item) {
      this.product.includes.push(item);
      this.check_ability_of_add();
    },
    delete_item(index) {
      this.product.includes.splice(index, 1);

      if (this.product.includes.length == 0) {
        this.tab_index = 0;
      }
      this.check_ability_of_add();
    },
    addToShoppingCart() {
      fbq("track", "AddToCart", {
        content_name: this.product.name,
      });
      console.log("fbq.track.AddToCart", {
        content_name: this.product.name,
      });

      this.should_disable = true;

      // let temp_roduct = { ...this.product };

      let temp_product = {
        name: this.product.name,
        type: this.product.type,
        id: this.product.id,
        includes: this.product.includes,
        quantity: this.product.quantity,
      };

      if (this.product.type == "pack") {
        temp_product.includes = temp_product.includes.map((merchandise) => {
          return merchandise.id;
        });
      }

      this.$inertia.put(
        "/api/shopping-cart",
        {
          payload: [temp_product],
        },
        {
          preserveState: true,
          preserveScroll: true,
          only: ["flash", "shopping_cart"],
          onSuccess: (page) => {
            if (page.props.flash.shopping_cart) {
              let interval = 3000;
              switch (page.props.flash.shopping_cart.severity) {
                case "warn":
                case "error":
                  interval = 10000;
                  break;
                case "info":
                  interval = 5000;
                  break;
              }

              this.$toast.add({
                severity: page.props.flash.shopping_cart.severity,
                summary: page.props.flash.shopping_cart.summary,
                detail: page.props.flash.shopping_cart.detail,
                group: "shopping-cart",
                life: interval,
              });
              this.$gemit("shopping_cart.quick_add.hide");
            }
          },
          onFinish: (visit) => {
            this.should_disable = false;
          },
        }
      );

      // axios
      //   .put("/api/shopping-cart", {
      //     payload: [temp_product],
      //   })
      //   .then((response) => {
      //     this.$emit("update:ShoppingCart", response.data);
      //     this.$toast.add({
      //       severity: "success",
      //       summary: "成功加入購物車",
      //       detail: this.product.name + " " + this.product.quantity + "個",
      //       life: 3000,
      //     });
      //     this.$gemit("shopping_cart.quick_add.hide");
      //   })
      //   .catch((error) => {
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "加入購物車失敗",
      //       detail: "請聯繫我們取得進一步的協助",
      //       closable: false,
      //       life: 5000,
      //     });
      //   })
      //   .finally(() => {
      //     this.should_disable = false;
      //   });
    },
    // removeFromShoppingCart(item) {
    //   axios
    //     .delete("/api/shopping-cart", {
    //       data: {
    //         payload: [
    //           {
    //             type: item.type,
    //             id: item.id,
    //             includes: item.includes,
    //           },
    //         ],
    //       },
    //     })
    //     .then((response) => {
    //       this.$emit("update:ShoppingCart", response.data);
    //       this.$toast.add({
    //         severity: "success",
    //         summary: "從購物車移除成功",
    //         detail: this.product.name + " " + this.product.quantity + "個",
    //         life: 3000,
    //       });
    //       this.$gemit("shopping_cart.quick_add.hide");
    //     })
    //     .catch((error) => {
    //       this.$toast.add({
    //         severity: "error",
    //         summary: "從購物車移除失敗",
    //         detail: "請聯繫我們取得進一步的協助",
    //         closable: false,
    //         life: 5000,
    //       });
    //     });
    // },
    goToProductPage(slug) {
      this.$gemit("shopping_cart.quick_add.hide");
      this.$inertia.visit(route("product", slug));
    },
  },
  mounted() {
    this.$gon(
      "shopping_cart.quick_add.toggle",
      (
        event,
        show_quantity,
        name,
        type,
        id,
        includes,
        quantity,
        stock,
        attributes
      ) => {
        this.show_quantity = show_quantity;
        if (this.$refs.QuickAdd.visible === false) {
          this.product = {
            name: name,
            type: type,
            id: id,
            includes: includes,
            quantity: quantity,
            stock: stock,
            attributes: attributes,
          };

          this.not_able_to_add = false;
        } else {
          this.product = {
            name: null,
            type: null,
            id: null,
            includes: null,
            quantity: 0,
            stock: 0,
            attributes: {},
          };

          this.not_able_to_add = true;
        }
        this.$refs.QuickAdd.toggle(event);
      }
    );

    this.$gon(
      "shopping_cart.quick_add_pack.toggle",
      (
        event,
        show_quantity,
        name,
        type,
        id,
        includes,
        quantity,
        stock,
        attributes
      ) => {
        this.contains_is_loading = true;
        if (this.$refs.QuickAdd_Pack.visible === false) {
          axios
            .get("/api/merchandises", {
              params: {
                ids: includes.join(","),
              },
            })
            .then((response) => {
              let options = response.data;

              switch (attributes.type.mode) {
                case "fixed":
                  // 固定商品
                  this.show_quantity = true;

                  this.product = {
                    name: name,
                    type: type,
                    id: id,
                    includes: options,
                    quantity: quantity,
                    stock: stock,
                    attributes: attributes,
                    options: options,
                    multiple: false,
                  };
                  this.tab_index = 0;
                  this.not_able_to_add = false;
                  break;

                case "single":
                  // 單選商品
                  this.show_quantity = false;

                  this.product = {
                    name: name,
                    type: type,
                    id: id,
                    includes: [],
                    quantity: quantity,
                    stock: stock,
                    attributes: attributes,
                    options: options,
                    multiple: false,
                  };
                  this.tab_index = 0;
                  this.not_able_to_add = true;
                  break;

                case "multiple":
                  this.show_quantity = false;
                  // 多選商品

                  this.product = {
                    name: name,
                    type: type,
                    id: id,
                    includes: [],
                    quantity: quantity,
                    stock: stock,
                    attributes: attributes,
                    options: options,
                    multiple: true,
                  };
                  this.tab_index = 0;
                  this.not_able_to_add = true;
                  break;
              }

              this.contains_is_loading = false;
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {});
        }

        if (this.$refs.QuickAdd_Pack.visible !== false) {
          this.product = {
            name: null,
            type: null,
            id: null,
            includes: null,
            quantity: 0,
            stock: 0,
            attributes: {},
          };
        }

        this.$refs.QuickAdd_Pack.toggle(event);
      }
    );

    this.$gon("shopping_cart.quick_add.hide", () => {
      this.$refs.QuickAdd.hide();
      this.$refs.QuickAdd_Pack.hide();
      this.product = {
        name: null,
        type: null,
        id: null,
        includes: null,
        quantity: 0,
        stock: 0,
        options: null,
        attributes: {},
      };

      this.not_able_to_add = false;
      this.contains_is_loading = true;
    });

    // this.$gon("shopping_cart.overview.toggle", (event) => {
    //   this.$refs.Overview.toggle(event);
    // });
  },
};
</script>

<style lang="postcss">
.pack-product-image {
  @apply w-[50px] h-[50px];
}

.quick-add-increase_button {
  @apply bg-fh-blue border-fh-blue;
}

.quick-add-decrease_button {
  @apply bg-fh-pink border-fh-pink;
}

.p-overlaypanel:after,
.p-overlaypanel:before {
  display: none;
}

.toast-category {
  @apply mb-5;
}

.toast-category .summary {
  @apply text-lg font-bold;
}
</style>